import React, { useState } from 'react';
import { withUserWriteAccess } from 'contexts/adminAccess';
import { useDataProvider, useRefresh } from 'react-admin';
import { Form } from 'react-final-form';

import { Button, makeStyles, Typography } from '@material-ui/core';
import { UserDetails } from '../types';
import { Dialog } from 'components/common';
import { Input } from 'components/form';
import { required } from 'components/form/validationRules';

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: 'none',
    color: theme.palette.secondary.contrastText,
  },
  error: {
    color: theme.palette.error.main,
  },
}));

interface Props {
  user: UserDetails;
}

const ChangeEmailButton = ({ user }: Props) => {
  const { email: currentEmail, id: rolloId, cognitoUserId: cognitoId } = user;

  const classes = useStyles();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();

  const [loading, setLoading] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleEditEmail = async ({ email }) => {
    setLoading(true);
    setError('');
    try {
      const response = await dataProvider.update('updateEmail', {
        data: {
          email,
          rolloId,
          cognitoId,
        },
      });

      handleCloseDialog();

      refresh();

      return response;
    } catch (error: any) {
      setError(error.message ?? JSON.stringify(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleOpenDialog}
        disabled={loading}
        className={classes.button}>
        Update email
      </Button>
      {openDialog && (
        <Form
          onSubmit={handleEditEmail}
          initialValues={{ email: currentEmail }}
          render={({ handleSubmit, submitting }) => {
            return (
              <form onSubmit={handleSubmit}>
                <Dialog
                  open={openDialog}
                  onCancel={handleCloseDialog}
                  title="Update email"
                  onConfirm={handleSubmit}
                  confirmText="Update"
                  submitting={submitting}>
                  <Input name="email" label="Email" validate={required} />
                  {error && <Typography className={classes.error}>{error}</Typography>}
                </Dialog>
              </form>
            );
          }}
        />
      )}
    </>
  );
};

export default withUserWriteAccess(ChangeEmailButton);
